import axios from "axios";

export default async function publishTheme(access_token, payload) {
  const response = await axios.post(
    `${process.env.REACT_APP_ORGANISER_API}/webpage/publish`,
    { ...payload },
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!response.data) {
    throw new Error("Some error occurred while fetching.");
  }
  if (response.data.error) {
    throw new Error(response.data.error);
  }

  return response.data;
}
